// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-title{
	font-weight: bold;
}

.line{
	border-bottom: 1px dotted black;
	line-height: 40px;
}

.account-btn {
	width: 100%;
	font-weight: bold;
}

.title-profile {
	color: black;
	float: left;
	font-weight: 600;
}

.text-profile {
	color: black;
	display: block;
	overflow: hidden;
	font-weight: normal;
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIm15LXByb2ZpbGUuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtDQUNDLGlCQUFpQjtBQUNsQjs7QUFFQTtDQUNDLCtCQUErQjtDQUMvQixpQkFBaUI7QUFDbEI7O0FBRUE7Q0FDQyxXQUFXO0NBQ1gsaUJBQWlCO0FBQ2xCOztBQUVBO0NBQ0MsWUFBWTtDQUNaLFdBQVc7Q0FDWCxnQkFBZ0I7QUFDakI7O0FBRUE7Q0FDQyxZQUFZO0NBQ1osY0FBYztDQUNkLGdCQUFnQjtDQUNoQixtQkFBbUI7QUFDcEIiLCJmaWxlIjoibXktcHJvZmlsZS5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLnBhZ2UtdGl0bGV7XG5cdGZvbnQtd2VpZ2h0OiBib2xkO1xufVxuXG4ubGluZXtcblx0Ym9yZGVyLWJvdHRvbTogMXB4IGRvdHRlZCBibGFjaztcblx0bGluZS1oZWlnaHQ6IDQwcHg7XG59XG5cbi5hY2NvdW50LWJ0biB7XG5cdHdpZHRoOiAxMDAlO1xuXHRmb250LXdlaWdodDogYm9sZDtcbn1cblxuLnRpdGxlLXByb2ZpbGUge1xuXHRjb2xvcjogYmxhY2s7XG5cdGZsb2F0OiBsZWZ0O1xuXHRmb250LXdlaWdodDogNjAwO1xufVxuXG4udGV4dC1wcm9maWxlIHtcblx0Y29sb3I6IGJsYWNrO1xuXHRkaXNwbGF5OiBibG9jaztcblx0b3ZlcmZsb3c6IGhpZGRlbjtcblx0Zm9udC13ZWlnaHQ6IG5vcm1hbDtcbn1cbiJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/all-modules/employees/my-profile/my-profile.component.css"],"names":[],"mappings":"AAAA;CACC,iBAAiB;AAClB;;AAEA;CACC,+BAA+B;CAC/B,iBAAiB;AAClB;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,cAAc;CACd,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA,47BAA47B","sourcesContent":[".page-title{\n\tfont-weight: bold;\n}\n\n.line{\n\tborder-bottom: 1px dotted black;\n\tline-height: 40px;\n}\n\n.account-btn {\n\twidth: 100%;\n\tfont-weight: bold;\n}\n\n.title-profile {\n\tcolor: black;\n\tfloat: left;\n\tfont-weight: 600;\n}\n\n.text-profile {\n\tcolor: black;\n\tdisplay: block;\n\toverflow: hidden;\n\tfont-weight: normal;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
